export default __webpack_public_path__ + "static/media/ewz.ae519ab3.jpg";